// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"rmib3","addToCartBlock":"oEPhC","addToCartBtn":"kAR-J","addToCartHover":"CgmAx"};